var map = {
	"./arrow-down.svg": 7064,
	"./calendar-overlay-close-button.svg": 7483,
	"./close.svg": 692,
	"./eraser.svg": 2816,
	"./import.svg": 1655,
	"./scroll-text.svg": 1169,
	"./send.svg": 9706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6678;